import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { ButtonType } from "../../button/button.type";

/** Rückfrage vor einer Aktion, die Eingegebenes verwirft. */
@Component({
  selector: "app-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmModalComponent {
  public readonly ButtonType = ButtonType;

  @Input() open = false;
  @Output() openChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() title = "";
  @Input() text = "";
  /** Die verwerfende Wahl — sie steht bewusst als leiserer Knopf unten. */
  @Input() confirmLabel = "";
  @Input() dismissLabel = "";

  @Output() confirmed: EventEmitter<void> = new EventEmitter<void>();

  public dismiss(): void {
    this.setOpen(false);
  }

  public confirm(): void {
    this.setOpen(false);
    this.confirmed.emit();
  }

  private setOpen(open: boolean): void {
    this.open = open;
    this.openChange.emit(open);
  }
}
